<template>

<div>

    <div class="owl-counter"> {{ current }} / {{ allNum }}</div> 

    <div class="owl-carousel" :id='id'>

        <div v-for='(item,i) in items'> 
            <a :href="'/project-idea/' + item.id" class="owl-link">
                <img :src='item.image' :alt='item.alt'> 
            </a>
            <div class="carousel-box">
                <h6 v-if="item.title && typeof item.title == 'string'">{{ item.title }}</h6>
                <p v-if="item.desc && typeof item.desc == 'string'">{{ item.desc }}</p>
            </div>      
        </div>

    </div>
     
</div>

</template>

<script>
    export default {

        mounted() {

            this.initCarousel();

        },

        beforeDestroy() {
            $( "#" + this.id ).owlCarousel('destroy');
        },

        created() {

            if( typeof this.ocid == 'string' ) {
                this.id = 'oc-' + this.ocid;
            }
  
        },

        props : ['opts', 'items', 'ocid'],

        data() {
            return {
                isReady : false,
                id      : 'oc-main',
                current : 1,
                allNum  : this.items.length,
            }
        },

        methods : {

            initCarousel() {

                //Default plugin options
                var defaultOpts = {
                    loop            : true,
                    margin          : 10,
                    items           : 2,
                    responsiveClass : true,
                    afterMove       : function( elem ) {

                    },
                    responsive:{
  
                        0 : {
                           
                        },

                        600 : {
                           items    : 3,
                        },
  
                        1000 : {
                       
                        }
                    }
                };
                
                if( typeof this.opts == 'object' ) {

                    //If options is passed by parent, merge with default
                    var opts = Object.assign( {}, defaultOpts, this.opts );
                
                } else {

                    //Use default optionss
                    var opts = defaultOpts;
                
                }

                var me = this;

                //Init carousel
                $(document).ready( function() {
                    var owl = $( "#" + me.id );

                    owl.owlCarousel( opts );

                    owl.on('changed.owl.carousel', function(event) {
                        me.current = event.page.index + 1;
                    });

                });
            },
            
        }

    }
</script>
